import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b937f69c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "light-text" }, "Choose which", -1))
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "selected-release panel bg-lighter-grey" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "no-space truncate-line" }
const _hoisted_7 = { class: "text-dark-grey" }
const _hoisted_8 = { class: "text-primary" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "table table-indented table-stack-medium" }
const _hoisted_12 = { class: "thead" }
const _hoisted_13 = { class: "tr row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "th col-1" }, null, -1))
const _hoisted_15 = { class: "th col-3" }
const _hoisted_16 = { class: "th col-3" }
const _hoisted_17 = { class: "th col-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "th col-2" }, " ISRC ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "th col-2" }, null, -1))
const _hoisted_20 = { class: "tbody" }
const _hoisted_21 = {
  key: 2,
  class: "row justify-center"
}
const _hoisted_22 = { class: "col-6 text-center" }
const _hoisted_23 = { class: "h2 text-center text-darkening-grey" }

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useGettext } from 'vue3-gettext'
import { getErrorMessage } from '@/helpers/errors'
import { formatReleaseArtistsToString } from '@/helpers/artists'
import IconUI from '@/components/CommonUI/IconUI.vue'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import ProgressBar from '@/components/AddWork/ProgressBar.vue'
import TrackItem from '@/components/AddWork/TrackItem.vue'
import { releaseStatusesValidForWorks } from '@/constants'
import { useReleasesStore } from '@/store/releases'
import { useTracksStore } from '@/store/tracks'
import { useUserStore } from '@/store/user'
import { useWorksStore } from '@/store/works'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddWritersTab',
  setup(__props) {

const { $gettext } = useGettext()

const route = useRoute()
const releasesStore = useReleasesStore()
const trackStore = useTracksStore()
const userStore = useUserStore()
const worksStore = useWorksStore()
const isLoading = ref(true)
const errorMessage = ref('')

onMounted(async () => {
  try {
    isLoading.value = true

    if (!releasesStore.selectedRelease) {
      const releaseId = route.params.releaseId as string

      await releasesStore.getRelease(Number(releaseId))
    }

    if (!releaseStatusesValidForWorks.includes(releasesStore!.selectedRelease!.statusId)) {
      throw new Error($gettext('This release is not active and cannot be registered.'))
    }

    if (releasesStore?.selectedRelease?.id && userStore?.user?.id) {
      await Promise.all([
        trackStore.getTracksWithoutWorks(releasesStore.selectedRelease.id),
        userStore.getLinkedAccounts(),
        worksStore.getUserWorksByStatuses([], false),
        userStore.getUserDetails(userStore.user.id),
      ])
    }

    isLoading.value = false
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("h1", null, [
      _hoisted_1,
      _createTextVNode(" tracks to register ")
    ])), [
      [_directive_translate]
    ]),
    _createVNode(ProgressBar, { active: 2 }),
    (isLoading.value)
      ? (_openBlock(), _createBlock(LoaderErrorBlock, {
          key: 0,
          "error-message": errorMessage.value
        }, null, 8, ["error-message"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(releasesStore).selectedRelease)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: _unref(releasesStore).selectedRelease.artwork?.small || require('@/assets/no-image.png'),
                    alt: _unref(releasesStore).selectedRelease.title
                  }, null, 8, _hoisted_4),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(releasesStore).selectedRelease?.title), 1),
                    _createElementVNode("small", _hoisted_7, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode("Album by:")
                      ])), [
                        [_directive_translate]
                      ]),
                      _createTextVNode("  "),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatReleaseArtistsToString)(_unref(releasesStore).selectedRelease?.artists)), 1)
                    ])
                  ]),
                  _createVNode(IconUI, {
                    name: "verified",
                    fill: "success"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(trackStore).tracks?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                    _createTextVNode(" Tracklist ")
                  ])), [
                    [_directive_translate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createTextVNode(" Title ")
                      ])), [
                        [_directive_translate]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createTextVNode(" Artist ")
                      ])), [
                        [_directive_translate]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createTextVNode(" Length ")
                      ])), [
                        [_directive_translate]
                      ]),
                      _hoisted_18,
                      _hoisted_19
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(trackStore).tracks, (track, index) => {
                      return (_openBlock(), _createBlock(TrackItem, {
                        key: track.id,
                        track: track,
                        index: index,
                        "data-testid": `track-item${track.id}`
                      }, null, 8, ["track", "index", "data-testid"]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_23, [
                    _createTextVNode(" All tracks of this release have been registered for publishing ")
                  ])), [
                    [_directive_translate]
                  ]),
                  _createVNode(_component_router_link, {
                    class: "button secondary",
                    to: { name: 'MyWorks' }
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode("Go to Dashboard")
                      ])), [
                        [_directive_translate]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
        ], 64))
  ], 64))
}
}

})